import {
  getEnv,
  getUA,
  converUrlParamsObj,
  isDevelopment,
  getLocationVars
} from '@/utils/utils'
import {
  ISharePageURLQueryParams,
  IBookSharePageURLQueryParams
} from '@scream/typings/interfaces/bookShare'

// 接口域名
const apiUrlList = {
  dev: 'https://dev-project-t-api.stardustworld.cn',
  test: 'https://dev-project-t-api.stardustworld.cn',
  prod: 'https://t-api-dcdn.stardustgod.com',
  gray: 'https://gray-t-game-api.stardustgod.com'
}

export const apiUrl: string = apiUrlList[isDevelopment ? 'dev' : getEnv()]

// 分享页数据上报的域名 上报给scream业务数据库，可能将来会改成上报到3.5
const dataReportUrlList = {
  dev: 'http://dev-project-t-api.stardustworld.cn',
  test: 'http://dev-project-t-api.stardustworld.cn',
  prod: 'https://t-api-dcdn.stardustgod.com',
  gray: 'https://gray-t-game-api.stardustgod.com'
}

export const dataReportApiUrl: string = dataReportUrlList[getEnv()]

export const downLoadUrlDic = {
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.stardust.screamreader',
  appStore: 'https://apps.apple.com/app/scream-read-write-romance/id1508942129'
}
// 'https://apps.apple.com/app/radish-fiction/id1076491465?ls=1'

const isIOS = getUA().ios

export const downLoadUrl = isIOS
  ? downLoadUrlDic.appStore
  : downLoadUrlDic.googlePlay

// project {string} 如果是”scream”说明是T项目，如果是”scream”或不传是跳到scream
const { project } = getLocationVars()

const schemeString = 'cmsscream'
const deeplinkTypeKey = 'nqns'

export const getAdjustDeeplink = ({
  customParams,
  type = 1001,
  pushType = 1,
  randomId,
  isForTest,
  contentType: contentTypeProp
}: ISharePageURLQueryParams): string => {
  // 为iOS同事开发调试deeplink保留的参数
  // const { lichen } = getLocationVars()
  // if (lichen) return lichen

  // ========
  // 直接用url里的adj_t 调试用

  const { isAdj, adj_t, contentType: contentTypeParam = 1 } = getLocationVars()
  const contentType = contentTypeProp ? contentTypeProp : contentTypeParam
  const t_ios = 'si0qv39'
  const t_android = 'hbmrxi0'

  const adj_t_h5 = 'tgxvsp4'
  // const adj_t_h5: string = isIOS ? t_ios : t_android

  if (adj_t) {
    // const adjDeepLink = encodeURIComponent(`${schemeString}://?type=${type}&parm1=${bookId}&pushType=${pushType}&randomId=${randomId}`)
    const adjDeepLink = encodeURIComponent(
      `${schemeString}://?${converUrlParamsObj({
        type,
        ...customParams,
        pushType,
        randomId
      })}`
    )
    let link = ''
    // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?type=${type}&parm1=${bookId}&adj_t=${adj_t}&adj_deep_link=${adjDeepLink}`
    // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?${converUrlParamsObj(
    //   {
    //     type,
    //     ...customParams,
    //     adj_t,
    //     adj_deep_link: adjDeepLink
    //   }
    // )}`

    const af_web_dp = encodeURIComponent(
      `https://5yxe.adj.st/?adj_t=${adj_t_h5}`
    )
    const deep_link_value = encodeURIComponent(
      `cmsscream://?${converUrlParamsObj({
        type,
        ...customParams,
        pushType,
        contentType
      })}`
    )
    link = `https://screamapp.onelink.me/FEPT?pid=test&af_web_dp=${af_web_dp}&c=CMS_APP_EXCHANGE_SCREAM&af_dp=${encodeURIComponent(
      'cmsscream://'
    )}&deep_link_value=${deep_link_value}`
    return link
  }

  // ==============
  // 广告投放 去掉isFromH5 换成新adj_t
  // 因为没有给新的追踪码 暂时注释掉
  // if (isAdj) {
  //   const adj_t_ios = 'pyxo2mp'
  //   const adj_t_android = 'd4yitmp'

  //   const adj_adj_t: string = isIOS ? adj_t_ios : adj_t_android

  //   // const adjDeepLink = encodeURIComponent(`${schemeString}://?type=${type}&parm1=${bookId}&pushType=${pushType}&randomId=${randomId}`)
  //   // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?type=${type}&parm1=${parm1}&adj_t=${adj_adj_t}&adj_deep_link=${adjDeepLink}`

  //   const adjDeepLink = encodeURIComponent(
  //     `${schemeString}://?${converUrlParamsObj({
  //       type,
  //       ...customParams,
  //       pushType,
  //       randomId
  //     })}`
  //   )
  //   return `https://${deeplinkTypeKey}.adj.st/${schemeString}?${converUrlParamsObj(
  //     {
  //       type,
  //       ...customParams,
  //       adj_t: adj_adj_t,
  //       adj_deep_link: adjDeepLink
  //     }
  //   )}`
  // }

  // ==============
  // 正常分享流程

  // isForTest === true 为了测试保留的功能 点击footer左侧scream 模拟广告运营流程 => is_from_H!== 1

  // adj_t 用过的
  // cnsqb7p   old   2020.11.12 安卓正常 ios正常
  // 4ntid1e   new   2020.11.12 安卓不正常  ios未知
  // tgxvsp4 ios 2020.11.13
  // hj8nn1a andorid 2020.11.13

  // 2021.4.26 scream
  // hbmrxi0 Android
  // si0qv39 iOS

  // const deepLink = encodeURIComponent(`${schemeString}://?type=${type}&parm1=${bookId}&is_from_H5=${isForTest ? 2 : 1}&pushType=${pushType}&randomId=${randomId}`)
  // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?type=${type}&parm1=${bookId}&adj_t=${adj_t_h5}&adj_deep_link=${deepLink}`

  // KISS44期时改动 2021-12-10
  let link = ''
  let deep_link_value_keys: any = {
    type,
    ...customParams
  }
  if (typeof randomId !== 'undefined') {
    deep_link_value_keys['randomId'] = randomId
  }
  if (type === 1001) {
    // 书籍分享页点击appflayer
    deep_link_value_keys.contentType = deep_link_value_keys = {
      ...deep_link_value_keys,
      contentType,
      pushType,
      is_from_H5: isForTest ? 2 : 1
    }
  }
  const deepLink = encodeURIComponent(
    `${schemeString}://?${converUrlParamsObj({
      ...deep_link_value_keys
    })}`
  )
  const af_web_dp = encodeURIComponent(`https://5yxe.adj.st/?adj_t=${adj_t_h5}`)
  link = `https://screamapp.onelink.me/FEPT?pid=test&af_web_dp=${af_web_dp}&c=CMS_APP_EXCHANGE_SCREAM&af_dp=${encodeURIComponent(
    'cmsscream://'
  )}&deep_link_value=${deepLink}`
  // return `https://${deeplinkTypeKey}.adj.st/${schemeString}?${converUrlParamsObj(
  //   {
  //     type,
  //     ...customParams,
  //     adj_t: adj_t_h5,
  //     adj_deep_link: deepLink
  //   }
  // )}`
  return link
}
// scream自定义协议
export const appSchemeLink = `${schemeString}://scream`

export const createBookSharePageUrl = ({
  bookId,
  type = 1001,
  pushType = 1,
  randomId
}: IBookSharePageURLQueryParams): string =>
  converUrlParamsObj({ bookId, type, pushType, randomId })
